import { render, staticRenderFns } from "./ThemeConfig.vue?vue&type=template&id=00318303&scoped=true&"
import script from "./ThemeConfig.vue?vue&type=script&lang=js&"
export * from "./ThemeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ThemeConfig.vue?vue&type=style&index=0&id=00318303&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00318303",
  null
  
)

export default component.exports